<template>
  <div id="myCal">
    <!-- 保费试算 -->
    <div class="cal_title">
            <div class="cutleft_">保费试算</div>
            <div class="cutoff_"></div>
    </div>
    <a-row class="changeStyle_">
        <a-col :span="20">
            <div class="group_">
                    <span class="label_">
                        保障计划：
                    </span>
                    <a-radio-group style="flex: 1;" class="flex_1" :options="calPlanOptions" :defaultValue="['1']" @change="onPlanChange" />
            </div>
            <div class="group_ group_2">
                <span class="label_ label_1">
                    出行天数：
                </span>
                <a-radio-group class="flex_1 width_" :style="{height: daysHeight}" :options="calDaysOptions" v-model="selectedDay" @change="onDaysChange" />
                <div class="daysBtn" v-if="isShowDaysBtn && calDaysOptions.length > 5" @click="isShowDays">更多选择</div>
                <div class="daysBtn daysBtn_1" v-else-if="calDaysOptions.length > 5" @click="()=>{isShowDaysBtn = true;daysHeight = '55px'}">收起</div>
                    <a-popconfirm 
                        placement="bottom"
                        @confirm="confirm"
                        @cancel="cancel"
                        okText="确定"
                        cancelText="取消"
                    >
                        <template slot="title">
                            <div class="daysPicker_">
                                <div class="daysLabel">出发时间</div>
                                <a-date-picker placeholder="请选择出发日期" :disabledDate="disabledStartDate" @change="onStartChange" />
                                <br />
                            </div>
                            <div class="daysPicker_">
                                <div class="daysLabel">结束时间</div>
                                <a-date-picker placeholder="请选择结束日期" :disabledDate="disabledEndDate" @change="onEndChange" />
                            </div>
                            <div class="daysPicker_">
                                <div class="daysLabel">出行天数</div>
                                <div class="daysLabel">共<span class="daysNum">{{daysNum}}</span>天</div>
                                <br />
                            </div>
                        </template>
                        <a-icon slot="icon" type="question-circle-o" style="display: none" />
                        <a href="#" :class="{active:isShowHover}"  @click="handleDayCal" class="daysBtn">{{`${daysNum > 0 ? '共' + daysNum + '天' : '天数计算'}`}}</a>
                    </a-popconfirm>
            </div>
            <div class="group_ group_1">
                <span class="label_">
                    承保年龄/人数：
                </span>
                <div class="ageRight_ flex_1">
                    <div class="calAge_" v-for="(item,index) in calAges" :key="index">
                        <div class="age_"  
                            @click="calAgeChange(item,index)" 
                            :class="{hover:item.isOn}">
                                {{item.isUnitSame ? `${item.min}-${item.max}${item.minUnitFormat}` 
                                : 
                                `${item.min}${item.minUnitFormat}-${item.max}${item.maxUnitFormat}`
                                }}
                        </div>
                        <a-input-number @blur="calAgeIptChange(item)" v-model="item.population" :class="{hover:item.population!==''}" class="calAge_input_" placeholder="人数"/>
                    </div>
                    <div class="calAge_">
                        <a-button style="width: 125px;" @click="handleCountPremium" class="calBtn_" type="primary">开始试算</a-button>
                    </div>
                </div>
                
            </div>
        </a-col>
        <a-col :span="4" class="calRight_">
                <div class="calTxt_">保费合计</div>
                <div class="calmoney_">¥ {{premiumSum}}</div>
                <a-button @click="handleToLocation" class="calBtn_" type="primary">立即投保</a-button>
        </a-col>
    </a-row>
  </div>
</template>


<script>
import moment from 'moment';
import api from '@/utils/api';

let calPlanOptions = [
    {
        label: '申根无忧计划A',
        value: '1'
    },
    {
        label: '申根无忧计划B',
        value: '2'
    },
    {
        label: '申根无忧计划C',
        value: '3'
    }
  ];
  let calDaysOptions = [
    {
        label: '1-5天',
        value: '1_5_d'
    },
    {
        label: '6-10天',
        value: '6_10_d'
    },
    {
        label: '11-20天',
        value: '11_20_d'
    },
    {
        label: '1-5天',
        value: '1_5_d'
    },
    {
        label: '6-10天',
        value: '6_10_d'
    },
    {
        label: '11-20天',
        value: '11_20_d'
    }
  ];
    let calAges = [
        {
            age:"0-10周岁",
            isOn: false,
            population: "",
            min: 30,
            minUnit: 'd',
            minUnitFormat: '天',
            max: 10,
            maxUnit: 'y',
            maxUnitFormat: '周岁',
            isUnitSame: false,
        },
    ]
export default {
    props: {
        planOptions: {
            type: Array,
            default: () => {return []}
        }
    },
    computed: {
        calPlanOptions () {
            return this.planOptions.map(item => {
                return {
                    label: item.name,
                    value: item.code
                }
            })
        }
    },
    data(){
        return {
            selectedDay: '',
            premiumSum: 0,
            daysNum: 0,  //计算天数
            startDate:'',
            endDate:'', 
            dateRecord: '',//记录出发日期与与当天的差值
            daysHeight: '55px',
            isShowHover: false, //是否显示hover样式
            isShowDaysBtn: true,//更多选择的展示
            calDaysOptions,//保费试算的天数
            calAges,//保费试算的年龄人数数组
            calAgePopulation: [], //选中的年龄人数数组
        }
    },
    mounted () {
        const { productCode } = this.$route.query
        this._productCode = productCode || '9068S'
        this.getPolicyOptions(this._productCode)
    },
    methods:{
        moment,
        handleDayCal () {
            this.isShowHover = !this.isShowHover;
        },
        handleCountPremium () {
            console.log('开始试算保费参数 -> ', this._planCode, this._planDay, this.calAges)
            let periodType = ''
            let policyPeriod = ''
            if (!this._planCode) {
                this.$message.info('请先选择保障计划！')
                return
            }
            if (this._planDay) {
                const planDaysArr = this._planDay.split('_')
                periodType = planDaysArr[2]
                policyPeriod = `${planDaysArr[0]}_${planDaysArr[1]}`
            } else {
                this.$message.info('请先选择出行天数！')
                return
            }
            const premiumReqDtos = this.calAges.filter(item => {
                return item.population && item.population > 0
            }).map(item => {
                return {
                    insuredAgePeriod: `${item.min}_${item.minUnit}_${item.max}_${item.maxUnit}`,
                    count: item.population,
                    plan: this._planCode,
                    periodType,
                    policyPeriod
                }
            })
            if (premiumReqDtos.length < 1) {
                this.$message.info('请先输入承保年龄人数！')
                return
            }
            const params = {
                premiumReqDtos,
                productCode: this._productCode
            }
            api.calPremiumTrial(params).then(res => res.data).then(data => {
                this.premiumSum = data.content
            }).catch(err => {
            })
        },
        getPremiumCountRules (productCode) {
          api.getPremiumCountRules({
            productCode
          }).then(res => res.data).then(data => {
            console.log('保费规则数据 -> ', data)
          })
        },
        getPolicyOptions (productCode) {
          api.getPolicyOptions({
            productCode
          }).then(res => res.data).then(data => {
            console.log('产品选项数据 -> ', data)
            const {policyAges, tripDays} = data.content
            const ageOptions = []
            const planDayOptions = []
            const formatUnit = (val, day) => {
                return val === 'y' ? (day === 1 ? '周岁' : '年' ) : val === 'm' ? '个月' : '天'
            }
            for (let i = 0; i < policyAges.length; i++) {
                let item = policyAges[i]
                let isUnitSame = true
                if (item.minimumAgeType !== item.maximumAgeType) {
                    isUnitSame = false
                }
                ageOptions.push({
                    min: item.minimumAge,
                    minUnit: item.minimumAgeType,
                    minUnitFormat: formatUnit(item.minimumAgeType),
                    max: item.maximumAge,
                    maxUnit: item.maximumAgeType,
                    maxUnitFormat: formatUnit(item.maximumAgeType),
                    isUnitSame,
                    isOn: false, // 控制选中样式
                    population: '', // 人数
                })
            }
            for (let i = 0; i < tripDays.length; i++) {
                let item = tripDays[i]
                const unit = formatUnit(item.dayType, 1)

                planDayOptions.push({
                    label: `${item.minimumDay}-${item.maximumDay}${unit}`,
                    value: `${item.minimumDay}_${item.maximumDay}_${item.dayType}`,
                    min: item.minimumDay,
                    max: item.maximumDay,
                    unit: item.dayType,
                    unitFormat: formatUnit(item.dayType, 1)
                })
            }
            this.calAges = ageOptions
            this.calDaysOptions = planDayOptions
          })
        },
        handleToLocation () {
            location.hash = ''
            location.hash = 'start'
            // let st = setTimeout(() => {
            //     location.hash = ''
            //     clearTimeout(st)
            // }, 2000);
        },
        disabledStartDate(current) {
            // Can not select days before today and today
            return current && current < moment().startOf('day');
        },
        disabledEndDate(current) {
            // Can not select days before today and today
            return current && current < moment().add(this.dateRecord-1,'days');
        },
        onStartChange(date, dateString) {
            console.log(date, dateString);
            if(dateString != ''){
                this.dateRecord = date.diff(moment().startOf('day'), "days")
            }
            // console.log("当天差值",this.dateRecord)
            this.startDate = date
            if(this.endDate&&this.startDate){
                this.daysNum = this.endDate.diff(this.startDate, 'days') + 1
            }
        },
        onEndChange(date, dateString) {
            console.log(date, dateString);
            this.endDate = date
            if(this.endDate&&this.startDate){
                this.daysNum = this.endDate.diff(this.startDate, 'days') + 1
            }
        },
         confirm(e) {
            let maxDay = 0
            const item = this.calDaysOptions.find(item => {
                let val = this.daysNum
                let max = item.max
                if (item.unit == 'm') {
                    val = Math.floor(val / 30)
                    max = max * 30
                }
                if (item.unit == 'y') {
                    val = Math.floor(val / 365)
                    max = max * 365
                }
                if (max > maxDay) {
                    maxDay = max
                }

                return item.min <= val && val <= item.max
            })
            if (item.min) {
                this._planDay = `${item.min}_${item.max}_${item.unit}`
            } else {
                this._planDay = `${maxDay}_${this.daysNum}_d`
            }
            this.selectedDay = ''
            console.log('计算天数 -> confirm -> ', e);
            // this.$message.success('Click on Yes');
        },
        cancel(e) {
            console.log(e);
            // this.$message.error('Click on No');
        },
        isShowDays(){//更多选择按钮的展示
            this.daysHeight = "auto"
            this.isShowDaysBtn = false
        },
        //判断年龄加样式
        calAgeChange(item,index){
            console.log("div->",item)
            this.calAges[index].isOn = !this.calAges[index].isOn
            let isExt = this.calAgePopulation.find(ele => {
                return ele.age == item.age
            })
            if(item.isOn === true && !isExt && item.population != ''){
                this.calAgePopulation.push(item)
            }
            console.log('承保年龄/人数',this.calAgePopulation)
        },
        //输入框的blur
        calAgeIptChange(item,index){
            console.log("ipt->",item)
            let isExt = this.calAgePopulation.find(ele => {
                return ele.age == item.age
            })
            if(item.isOn === true && !isExt && item.population != ''){
                this.calAgePopulation.push(item)
            }
            console.log('承保年龄/人数',this.calAgePopulation)
        },
        //保障计划checkbox
        onPlanChange(e) {
            console.log('checked = ', e);
            this._planCode = e.target.value
        },
        //天数checkbox
        onDaysChange(e) {
            console.log('checked = ', e);
            this._planDay = e.target.value
        },
    }
}
</script>

<style  lang="scss">
        .active{
            color: rgba(254,143,45,1) !important;
            border: 1px solid rgba(254,143,45,1) !important;
             &::after {
                 border-color: rgba(254,143,45,1) !important;
             }
        }
        // 全局气泡框样式
        .ant-popover-placement-bottom{
            .ant-popover-buttons{
                text-align: center;
                .ant-btn {
                    width: 85px;
                    height: 32px;
                    font-size:10px;
                    font-family:Microsoft YaHei UI;
                    font-weight:400;
                }
            }
            .ant-popover-message-title {
                padding-left: 0;
            }
        }
        .daysPicker_{
            display: flex;
            align-items: center;
            margin: 10px;
            .daysLabel{
                margin-right: 10px;
                font-size:9px;
                font-family:Microsoft YaHei UI;
                font-weight:400;
                color:rgba(102,102,102,1);
                display: flex;
                align-items: center;
                .daysNum{
                    font-size:20px;
                    font-family:Microsoft YaHei UI;
                    font-weight:600;
                    color:rgba(254,143,45,1);
                }
            }
        }

        .cal_title {
            margin: 30px 0 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .cutleft_ {
                font-size: 16px;
                font-family: Microsoft YaHei UI;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                // width: 10%;
            }
            .cutoff_ {
                // width:90%;
                flex: 1;
                height: 5px;
                background: #f0f0f0;
            }
        }
//radio数组
#myCal{
     .calRight_{
        height: 215px;
        width: 200px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(229,229,229,1);
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        .calTxt_{
            font-size:10px;
            font-family:Microsoft YaHei UI;
            font-weight:400;
            color:rgba(102,102,102,1);
        }
        .calmoney_{
            font-size:19px;
            font-family:Microsoft YaHei UI;
            font-weight:bold;
            color:rgba(254,143,45,1);
        }
        .calBtn_{
            width:125px;
            height:31px;
            background:rgba(254,143,45,1);
        }
    }
    .ageRight_{
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;
        .calAge_{
            display: flex;
            margin: 10px;
            .calAge_input_{
                width: 80px;
            }
            .age_{
                height: 32px;
                min-width: 80px;
                padding: 0 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                border:1px solid rgba(229,229,229,1);
                font-size: 14px;
                color:rgba(102,102,102,1);
                margin-right: 5px;
            }
            .hover{
                color: rgba(254,143,45,1);
                border: 1px solid rgba(254,143,45,1);
            }
        }
    }

  .changeStyle_{
    display: flex;
    align-items: center;
    .group_{
      margin: 30px 0;
       display: flex;
        align-items: center;
        .flex_1{
            // flex: 1;
        }
        .width_{
            max-width: 590px;
            overflow: hidden;
        }
        .daysBtn{
            margin-top: 8px;
            font-family:Microsoft YaHei UI;
            font-weight:400;
            font-size:10px;
            color:rgba(51,51,51,1);
            border:1px solid rgba(229,229,229,1);
            padding: 8px 34px 8px 22px;
            margin-right: 10px;
            position: relative;
            text-decoration: none;
            cursor: pointer;
            &::after {
                position: absolute;
                top: 11px;
                right: 18px;
                display: block;
                content: '';
                width: 8px;
                height: 8px;
                border-bottom: 2px solid #666666;
                border-right: 2px solid #666666;
                transform: rotateZ(45deg);
            }
        }
        .daysBtn_1{
            &::after {
                border-bottom: 0;
                border-right:0;
                top:15px;
                border-left: 2px solid #666666;
                border-top:2px solid #666666;;
            }
        }
        
      .label_{
        margin-right: 10px;
        font-family:Microsoft YaHei UI;
        font-weight:600;
        color:rgba(51,51,51,1);
        display: inline-block;
        width: 108px;
        text-align: right;
      }
      .label_1{
        margin-top: 18px;
      }
      .ant-radio-group{
        .ant-radio-wrapper-checked{
            font-weight: 600;
            color: rgba(254,143,45,1);
            border: 1px solid #fe8f2d;
            padding: 5px 10px;
          }
        }
      .ant-radio-inner{
          display: none !important;
        }
        .ant-radio-wrapper {
          margin: 10px;
          margin-right: 20px;
          font-weight: 600;
          padding: 5px 10px;
          border:1px solid rgba(229,229,229,1);
        }
      }
      .group_2{
       align-items: flex-start;
      }
  }
}
</style>